const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, ob) => {
      requestAnimationFrame(() => callback(entries, ob));
    });
  }
};